const VALUE_DATA = [
  {
    title: 'YTC',
    description: 'Your Tech Company is a team of engineers who are passionate about building high-quality software products',
  },
  {
    title: 'Honest',
    description: 'Being honest is the only way to become trustworthy and be reliable. We speak up whenever are are stuck, going through rough time or made a mistake',
  },
  {
    title: 'Independent',
    description: 'Our team members can solve problems and work independently by putting themselves in shoes of product users',
  },
  {
    title: 'Strong Work Ethics',
    description: 'Work matters. It’s what puts food on the table as well as brings meaning to our life. We bring our A game in all our engagements',
  },
  {
    title: 'Passionate',
    description: 'We are a passionate bunch and enjoy working with passionate people. We strongly believe that without it, no one would win',
  },
  {
    title: 'Committed',
    description: 'We commit & deliver. It is impossible to build a product if you cannot depend on us',
  },
];

export { VALUE_DATA }